import {CaptchaStatusGenericFormError} from './CaptchaStatusGenericFormError.js'
import {CaptchaStatusNotActiveFormError} from './CaptchaStatusNotActiveFormError.js'
import {CaptchaStatusNotFoundFormError} from './CaptchaStatusNotFoundFormError.js'
import {ConfigurationNotFoundFormError} from './ConfigurationNotFoundFormError.js'
import {GenericFormError} from './GenericFormError.js'
import {SpecsFormError} from './SpecsFormError.js'

export class FormErrorsFactory {
  static specsFormError = message => new SpecsFormError(message)

  static captchaStatusGenericFormError = message => new CaptchaStatusGenericFormError(message)

  static captchaStatusNotFoundFormError = message => new CaptchaStatusNotFoundFormError(message)

  static captchaStatusNotActiveFormError = message => new CaptchaStatusNotActiveFormError(message)

  static configurationNotFoundFormError = message => new ConfigurationNotFoundFormError(message)

  static genericFormError = message => new GenericFormError(message)
}
